export const SET_DATA = 'SET_DATA';
export const DELETE_DATA = 'DELETE_DATA';
export const DELETE_INDEX = 'DELETE_INDEX';
